import { useQuery } from "@tanstack/react-query";
import { getConstructionProjectDetails } from "../../api/construction";

export default function useProjectByProperty(propertyUid: string) {
  return useQuery({
    queryKey: ["project", propertyUid],
    queryFn: () => getConstructionProjectDetails(propertyUid),
    select: (response) => response.data,
    enabled: !!propertyUid,
  });
}
